<template>
  <section class="innerpages animate__animated animate__slideInRight">
    <div class="container ">
      <div class="row">
        <div class="col-md-12 listPage">
          <h1 class="text-truncate" :title="marketingData[0]?.sub_project_name">{{ marketingData[0]?.sub_project_name }}
          </h1>
          <h2 class="text-truncate" :title="marketingData[0]?.enquiry_source_name"><span class="source">Source:</span>
            {{
              marketingData[0]?.enquiry_source_name }}</h2>
          <div class="card">
            <b-table :items="marketingData" :fields="fields" responsive show-empty thead-tr-class="text-nowrap"
              tbody-tr-class="dataDivider">
              <template v-slot:empty="scope">
                <h5 class="noData">No Data</h5>
              </template>
              <template v-slot:cell(qualified_leads_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, 'lead_is_qualified')">
                  {{ row.value }}
                </span>
              </template>

              <template v-slot:cell(booking_done_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, 'lead_sub_statuses')">
                  {{ row.value }}
                </span>
              </template>

              <template v-slot:cell(visit_done_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, 'visited')">
                  {{ row.value }}
                </span>
              </template>

              <template v-slot:cell(visit_scheduled_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, 'visit_scheduled')">
                  {{ row.value }}
                </span>
              </template>

              <template v-slot:cell(re_engaged_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, 're_engaged')">
                  {{ row.value }}
                </span>
              </template>

              <template v-slot:cell(leads_count)="row">
                <span class="text-primary" @click.stop="goToLeads(row.item, '')">
                  {{ row.value }}
                </span>
              </template>
            </b-table>
            <b-pagination v-if="totalRows > perPage" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
              align="center" aria-controls="mcr-table"></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      sortBy: 'count',
      sortDesc: false,
      marketingData: [],
      pagination: null,
      currentPage: 1,
      fields: [
        { key: 'ads_keyword', label: 'Keyword' },
        { key: 'physical_pincode', label: 'Location' },
        { key: 'physical_location_name', label: 'Location Name' },
        { key: 'utm_source', label: 'UTM Source' },
        { key: 'utm_campaign', label: 'UTM Campaign' },
        { key: 'ads_group_id', label: 'Ads Group ID' },
        { key: 'ads_name', label: 'Ads Name' },
        { key: 'campaign_id', label: 'Campaign ID' },
        { key: 'device', label: 'Device' },
        { key: 'campaign_name', label: 'Campaign Name' },
        { key: 'keyword_type', label: 'Keyword Type' },
        { key: 'ad_strategy', label: 'Ad Strategy' },
        { key: 'qualified_leads_count', label: 'Qualified' },
        { key: 'booking_done_count', label: 'Booking Done' },
        { key: 'visit_done_count', label: 'Visit Done' },
        { key: 'visit_scheduled_count', label: 'Visit Scheduled' },
        { key: 're_engaged_count', label: 'Re-Engage' },
        { key: 'leads_count', label: 'Total' },
      ]
    }
  },
  watch: {
    currentPage() {
      this.getDetails();
    }
  },
  computed: {
    perPage() {
      return this.pagination?.per_page || 30;
    },
    totalRows() {
      return this.pagination?.total_count || 0;
    },
    activeItem() {
      return this.$store.getters.activeItem;
    },
  },
  mounted() {
    this.$store.dispatch('setActiveTitle', "Marketing Campaign Report");
    this.getDetails();
  },
  methods: {
    getDetails() {
      let queryParams = {
        ...this.$route.query
      };
      let searchParams = new URLSearchParams(queryParams).toString();
      let url = `/marketing_campaign_report/${this.activeItem.sub_project_id}/source/${this.activeItem.enquiry_source_id}?page=${this.currentPage}&${searchParams}`;
      this.$axios.get(url)
        .then(res => {
          if (res) {
            this.marketingData = res.data.data;
            this.pagination = res.data.pagination;
          }
        })
        .catch((err) => {
          if (err.response.status === 500) {
            swal({
              title: "Server Error!",
              icon: "error",
            });
          } else {
            swal({
              title: "Error",
              text: err.response.data.message,
              icon: "error",
            });
          }
        });
    },
    goToLeads(item, type) {
      const leadFilters = {
        lead_is_qualified: { lead_is_qualified: true },
        lead_sub_statuses: { lead_sub_statuses: [10] },
        visit_scheduled: { lead_sub_statuses: [6] },
        visited: { visited: true },
        re_engaged: { re_engaged: true },
      };
      let filter = {};
      switch (type) {
        case 'lead_is_qualified':
          filter = leadFilters.lead_is_qualified;
          break;
        case 'lead_sub_statuses':
          filter = leadFilters.lead_sub_statuses;
          break;
        case 'visited':
          filter = leadFilters.visited;
          break;
        case 'visit_scheduled':
          filter = leadFilters.visit_scheduled;
          break;
        case 're_engaged':
          filter = leadFilters.re_engaged;
          break;
        default:
          filter = {};
      }
      this.$router.push({
        path: `/leads/for/marketing-campaign-report-leads/${item.sub_project_id}`,
        query: {
          ...this.$route.query,
          ads_keyword: item.ads_keyword,
          physical_pincode: item.physical_pincode,
          utm_source: item.utm_source,
          utm_campaign: item.utm_campaign,
          ads_group_id: item.ads_group_id,
          ads_name: item.ads_name,
          campaign_id: item.campaign_id,
          device: item.device,
          campaign_name: item.campaign_name,
          keyword_type: item.keyword_type,
          ad_strategy: item.ad_strategy,
          enquiry_source_id: item.enquiry_source_id,
          physical_location_name: item.physical_location_name,
          ...filter,
        },
      });
    }

  }
}
</script>

<style scoped>
.innerpages h1,
h2,
h3 {
  font-size: 20px;
  font-weight: 800;
  color: #000000;
  opacity: .2;
}

.source {
  font-weight: 600;
}

.other-status {
  font-weight: 500;
  font-size: 14px;
}

.icon-arrow {
  display: inline-flex;
  align-items: center;
  gap: 40px
}

@media screen and (width: 412px) {
  .icon-arrow {
    gap: 48px;
  }
}

@media screen and (width: 430px) {
  .icon-arrow {
    gap: 50px;
  }
}
</style>